import React from 'react';
import PropTypes from 'prop-types';

import { MapIcon, Squares2X2Icon } from '@heroicons/react/24/solid';

const MapButton = ({ action, text, hasIcon = true, variant = 'map' }) => {
  const Icon = variant === 'list' ? Squares2X2Icon : MapIcon;
  return (
    <button
      type="button"
      onClick={action}
      className="
        group relative inline-flex items-center gap-2.5 pl-3 pr-4 py-2.5
        rounded-full bg-yellow-03 text-white font-sans
        ring-1 ring-yellow-03/40
        shadow-[0_10px_28px_-8px_rgba(127,96,0,0.55),0_2px_4px_-1px_rgba(127,96,0,0.25)]
        transition-all duration-200 ease-out
        hover:shadow-[0_16px_36px_-8px_rgba(127,96,0,0.65),0_3px_6px_-1px_rgba(127,96,0,0.3)]
        hover:-translate-y-0.5
        active:translate-y-0 active:shadow-md
        focus:outline-none focus-visible:ring-2 focus-visible:ring-white/70
      "
    >
      {hasIcon && (
        <span className="grid place-items-center w-7 h-7 rounded-full bg-white/15 backdrop-blur-sm">
          <Icon className="w-4 h-4 text-white" />
        </span>
      )}
      <span className="text-[13px] font-bold tracking-tight">{text}</span>
    </button>
  );
};

MapButton.propTypes = {
  action: PropTypes.func,
  text: PropTypes.string,
  hasIcon: PropTypes.bool,
  variant: PropTypes.oneOf(['map', 'list']),
};

export default MapButton;
